import { OrderPayment, OrderPaymentCC, OrderPaymentRW, PaymentTypeCode } from '../order'

export const isOrderPaymentCC = (payment: OrderPayment): payment is OrderPaymentCC =>
  payment.typeCode === PaymentTypeCode.Values.CC

export const isOrderPaymentRW = (payment: OrderPayment): payment is OrderPaymentRW =>
  payment.typeCode === PaymentTypeCode.Values.RW
